import { Box, Typography, useMediaQuery, useTheme } from "@mui/material"
import React from "react"
import { Colors } from "../../constants/colors"
import { Agent, AgentLanguages, CountryFlags } from "../../types/Agent"

interface CallLanguageProps {
  agent: Agent
}

export default function CallLanguage({ agent }: CallLanguageProps) {
  if (!agent) return null

  const agentLanguage = agent?.language || AgentLanguages.English
  const FlagComponent =
    CountryFlags[agentLanguage] || CountryFlags[AgentLanguages.English]

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

  const top = `var(--spacing-tokens-size-in-px-spacing-spacing-${isMobile ? "6xl" : "5xl"})`
  const right = `var(--spacing-tokens-size-in-px-spacing-spacing-${isMobile ? "xl" : "5xl"})`

  return (
    <Box
      padding={"6px 12px"}
      position="absolute"
      top={top}
      right={right}
      color="black"
      sx={{
        backgroundColor: "var(--colors-light-background-bg-overlay-2)",
        backdropFilter: "blur(3px)",
        border: "1px solid var(--colors-light-background-bg-overlay-2)",
        borderRadius: "50px",
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
        zIndex: 1,
        height: "30px",
      }}
    >
      <FlagComponent width={22} height={22} title={agentLanguage} />
      <Typography variant="body2" color={Colors.White}>
        {agentLanguage.toUpperCase()}
      </Typography>
    </Box>
  )
}
